/**
 * Created by claudio iozzia on 22/06/2017.
 */
import {AcceptorOutputFn} from "../../../../models/acceptor/IAcceptor";
import {Ic} from "../../../../models/common";
import {Utils} from "../../../../common/utils";
import {ISingleOutput} from "../../../../models/ISpec";
import {IAppSpec} from "../../../../Redux/selector.state";



export const acceptSingle_common_Vout: AcceptorOutputFn = (a: Ic, spec: IAppSpec, out: ISingleOutput<number>): boolean => {
  /* check if single voltage output is defined and inside the bounds */
  const ret = (!Utils.isValueReal(out.voltage)) || ((a.vout_min <= out.voltage && out.voltage <= a.vout_max));
  // console.log("acceptSingle_common_Vout", ret, out, (!Utils.isValueReal(out.voltage)), ((a.vout_min <= out.voltage && out.voltage <= a.vout_max)) );
  return ret;
};

export const acceptSingle_common_Iout: AcceptorOutputFn = (a: Ic, spec: IAppSpec, out: ISingleOutput<number>): boolean => {
  /* check if single current output is defined and inside the bounds */
  const ret = (!Utils.isValueReal(out.current)) || ((0 <= out.current && out.current <= a.iout_max));
 // console.log("acceptSingle_common_Iout", ret);
  return ret;
};

